
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dqR1S", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "CoordinationStopProvider", () => $ea7de9b9004f52fd$export$83d026e3dd5706d);
$parcel$export(module.exports, "SpotlightTourCardInner", () => $ea7de9b9004f52fd$export$c5cea928f65b46cd);
$parcel$export(module.exports, "default", () => $ea7de9b9004f52fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5ujeO = parcelRequire("5ujeO");
var $imZsD = parcelRequire("imZsD");
var $1QiBP = parcelRequire("1QiBP");

var $dS3PR = parcelRequire("dS3PR");

var $eGLgs = parcelRequire("eGLgs");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $761Hb = parcelRequire("761Hb");

var $8QPci = parcelRequire("8QPci");

var $1oOi0 = parcelRequire("1oOi0");

var $dZX70 = parcelRequire("dZX70");
const $ea7de9b9004f52fd$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $ea7de9b9004f52fd$export$c5cea928f65b46cd = ({ mode: mode, view: view, hasIssueResults: hasIssueResults = false, isAiEnabled: isAiEnabled })=>{
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onSetActiveCard: onSetActiveCard } = (0, $8QPci.useSpotlightCoordinationActions)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'ninSpotlightTour'
    });
    const fireStartButtonAnalyticsEvent = (stop)=>{
        if (isAiEnabled) {
            // @ts-expect-error Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent.clone(), 'start', {
                isAiEnabled: isAiEnabled
            });
            onSetActiveCard((0, $761Hb.cardKeys).GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL, stop);
            return;
        }
        // @ts-expect-error Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent.clone(), 'start', {
            mode: mode,
            view: hasIssueResults ? view : (0, $1oOi0.views).detail,
            hasIssueResults: hasIssueResults
        });
        stop && stop();
    };
    const fireDismissButtonAnalyticsEvent = ()=>{
        // @ts-expect-error Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent.clone(), 'dismiss');
    };
    if (isSpotlightActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $1oOi0.getEngagementPlatformlMessageId)((0, $1oOi0.TOUR_MESSAGE_ID)),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea7de9b9004f52fd$export$83d026e3dd5706d, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea7de9b9004f52fd$var$SpotlightWrapper, {
            "data-testid": "issue-navigator-changeboarding.common.ui.spotlight.spotlight-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
            key: "nin.changeboarding.start",
            width: 364,
            heading: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZX70.default).spotlightTitleIssueTermRefresh : (0, $dZX70.default).spotlightTitle),
            actions: [
                {
                    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                        weight: "medium",
                        testId: "issue-navigator-changeboarding.common.ui.spotlight.spotlight-card.start"
                    }, formatMessage((0, $dZX70.default).spotlightButtonStartTourText)),
                    onClick: ()=>{
                        setIsSpotlightActive(false);
                        fireStartButtonAnalyticsEvent(stop);
                    }
                },
                {
                    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                        weight: "medium",
                        testId: "issue-navigator-changeboarding.common.ui.spotlight.spotlight-card.dismiss"
                    }, formatMessage((0, $dZX70.default).spotlightButtonDismissText)),
                    onClick: ()=>{
                        setIsSpotlightActive(false);
                        fireDismissButtonAnalyticsEvent();
                        stop?.();
                    },
                    appearance: 'subtle'
                }
            ]
        }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZX70.default).spotlightDescIssueTermRefresh : (0, $dZX70.default).spotlightDesc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
            action: "viewed",
            actionSubject: "screen",
            actionSubjectId: "ninSpotlightStartCard"
        }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $ea7de9b9004f52fd$var$SpotlightTourCard = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea7de9b9004f52fd$export$c5cea928f65b46cd, {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    }));
var $ea7de9b9004f52fd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = $ea7de9b9004f52fd$var$SpotlightTourCard;
const $ea7de9b9004f52fd$var$SpotlightWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _19pkpxbi _1xi2pxbi _1pby1fw0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("761Hb", function(module, exports) {

$parcel$export(module.exports, "cardKeys", () => $d137429970660ed4$export$79399c5778983d77);
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $d137429970660ed4$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("8QPci", function(module, exports) {

$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $1bf3a4be42170bcd$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $1bf3a4be42170bcd$export$d0297e733168e478);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $1bf3a4be42170bcd$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $1bf3a4be42170bcd$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $1bf3a4be42170bcd$var$Store = (0, $iXqE5.createStore)({
    initialState: $1bf3a4be42170bcd$var$initialState,
    actions: $1bf3a4be42170bcd$var$actions
});
const $1bf3a4be42170bcd$export$ac706a6842f43035 = (0, $3sQ5x.createHook)($1bf3a4be42170bcd$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $1bf3a4be42170bcd$export$d0297e733168e478 = (0, $3sQ5x.createActionsHook)($1bf3a4be42170bcd$var$Store);

});

parcelRegister("dZX70", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0d14537e63124af$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $d0d14537e63124af$var$messages = (0, $7VHMR.defineMessages)({
    spotlightTitle: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-title",
        "defaultMessage": "Welcome to the new issue search \uD83D\uDC4B"
    },
    spotlightDesc: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-desc",
        "defaultMessage": "Check out our new issue search to find, view, and action issues across your Jira site."
    },
    spotlightButtonStartTourText: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-button-start-tour-text",
        "defaultMessage": "Show me"
    },
    spotlightButtonDismissText: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-button-dismiss-text",
        "defaultMessage": "No, thanks"
    },
    spotlightTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-title-issue-term-refresh",
        "defaultMessage": "Welcome to the new way to search for work items \uD83D\uDC4B"
    },
    spotlightDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.spotlight.spotlight-card.spotlight-desc-issue-term-refresh",
        "defaultMessage": "Check out our new search to find, view, and action work across your Jira site."
    }
});
var $d0d14537e63124af$export$2e2bcd8739ae039 = $d0d14537e63124af$var$messages;

});



//# sourceMappingURL=async-nin-spotlight.e7652aed.js.map
